<template>
    <div class="FieldHelpWrap">
        <div class="FieldHelpWrap__input">
            <InputGenerator
                v-if="groupFields.fields"
                :name="name"
                :inputData="dataArray"
                :namespace="fieldNamespace"
                :key="fieldNamespace"
                :fieldsInGroup="parseInt(fieldsInGroup)"
                :groupInline="groupInline"
                :groupNumbered="groupNumbered"
                :groupFields="groupFields.fields"
            />
        </div>
        <div
            class="FieldHelpWrap__help"
            v-if="helpText"
        >
            <HelpModal
                v-if="helpText"
                :text="helpText"
                :title="helpTitle"
            />
        </div>
    </div>
</template>


<script>
import SubmissionBoilerplate from '@/views/Public/Field/Fields/SubmissionBoilerplate';
import FieldGroupBoilerplate from '@/views/Public/Field/Fields/Groups/FieldGroupBoilerplate';
import InputGenerator from '@/views/Common/Input/Groups/InputGenerator';

export default {
    components: { InputGenerator },
    mixins: [ SubmissionBoilerplate, FieldGroupBoilerplate ]
};
</script>
